module.exports = __webpack_public_path__ + "img/yujing.15cce270.jpg";